module.exports = __webpack_public_path__ + "img/EROCION_ABAJO.png";